import { useSelector } from "react-redux";
import { useGetProductQuery } from "../../store/services/productApi.js";
import {
  GEN_1_MACHINE_PRODUCT_ID,
  DUET_MACHINE_PRODUCT_ID,
  MACHINE_DISCOUNT_MAP,
} from "../../utils/constants.js";
import useHandlers from "~/hooks/useHandlers";
import "./PriceSummary.css";

const PriceSummary = ({ data, selectedCapsules }) => {
  const frequency = useSelector((state) => state.frequency.frequency);
  const selectedMachineVariantId = useSelector((state) => state.machine.selectedMachineVariantId);

  const { progressDiscount } = useHandlers({ selectedCapsules });

  const { discount } = progressDiscount(data);

  const {
    data: gen1MachineProduct,
    error: gen1Error,
    isLoading: gen1Loading,
  } = useGetProductQuery(GEN_1_MACHINE_PRODUCT_ID);

  const {
    data: duetMachineProduct,
    error: duetError,
    isLoading: duetLoading,
  } = useGetProductQuery(DUET_MACHINE_PRODUCT_ID);

  const subtotal = selectedCapsules.reduce((total, capsule) => {
    return total + capsule.price * capsule.quantity;
  }, 0);

  const discountAmount = (subtotal * discount) / 100.0;

  const minCycles = frequency.split("-deliveries-commitment")[0];
  // console.log("minCycles", minCycles);

  const machineDiscount =
    selectedMachineVariantId && MACHINE_DISCOUNT_MAP[minCycles]
      ? MACHINE_DISCOUNT_MAP[minCycles]
      : 0;

  // console.log("machineDiscount", machineDiscount);

  let machinePrice = 0;

  if (
    gen1MachineProduct &&
    gen1MachineProduct.variants.edges[0].node.id.includes(selectedMachineVariantId)
  ) {
    machinePrice = parseFloat(gen1MachineProduct.variants.edges[0].node.price.amount);
  } else if (
    duetMachineProduct &&
    duetMachineProduct.variants.edges[0].node.id.includes(selectedMachineVariantId)
  ) {
    machinePrice = parseFloat(duetMachineProduct.variants.edges[0].node.price.amount);
  }

  // console.log("machinePrice", machinePrice);
  // console.log("subtotal", subtotal);
  // console.log("discountAmount", discountAmount);

  const total = subtotal + machinePrice - discountAmount - machineDiscount;

  if (gen1Loading || duetLoading) {
    return <p>Loading price details...</p>;
  }

  if (gen1Error) {
    return <p>Error loading Gen 1 Machine: {gen1Error.message}</p>;
  }
  if (duetError) {
    return <p>Error loading Duet Machine: {duetError.message}</p>;
  }

  return (
    <div className="price-summary">
      <div className="price-summary-item">
        <span className="price-summary-item-label">Subtotal:</span>
        <span className="price-summary-item-price">${(subtotal + machinePrice).toFixed(2)}</span>
      </div>
      <div className="price-summary-item">
        <span className="price-summary-item-label">Discount:</span>
        <span className="price-summary-item-price">
          ${(discountAmount + machineDiscount).toFixed(2)}
        </span>
      </div>
      <div className="price-summary-item">
        <span className="price-summary-item-label">Total:</span>
        <span className="price-summary-item-price">${total.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default PriceSummary;
